export const SET_HISTORY = (newHistory) => {
  return { type: "SET_HISTORY", history: newHistory }
}
